import script from "./SortPaginationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SortPaginationTable.vue?vue&type=script&setup=true&lang=js"

import "./SortPaginationTable.vue?vue&type=style&index=0&id=3a5f5fe4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5f5fe4"]])

export default __exports__